The set of questions presented to the candidate during the application.
